var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.000549316,
    y: 0.000976562,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#6F767E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13617_107644)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.14877 5.03762H9.85247V7.25984C9.85247 8.28259 9.02337 9.11169 8.00062 9.11169C6.97787 9.11169 6.14877 8.28259 6.14877 7.25984V5.03762ZM5.40803 5.03762C5.40803 4.62852 5.73967 4.29688 6.14877 4.29688H9.85247C10.2616 4.29688 10.5932 4.62852 10.5932 5.03762H11.334C11.743 5.03762 12.0747 5.36926 12.0747 5.77836V6.5191C12.0747 7.3373 11.4114 8.00058 10.5932 8.00058H10.4858C10.2013 8.95684 9.37979 9.68188 8.37099 9.82618V10.9635H9.4821C9.68665 10.9635 9.85247 11.1294 9.85247 11.3339C9.85247 11.5385 9.68665 11.7043 9.4821 11.7043H6.51914C6.31459 11.7043 6.14877 11.5385 6.14877 11.3339C6.14877 11.1294 6.31459 10.9635 6.51914 10.9635H7.63025V9.82618C6.62145 9.68188 5.79998 8.95684 5.51539 8.00058H5.40803C4.58983 8.00058 3.92654 7.3373 3.92654 6.5191V5.77836C3.92654 5.36926 4.25819 5.03762 4.66728 5.03762L5.40803 5.03762ZM5.40803 5.77836H4.66728V6.5191C4.66728 6.9282 4.99893 7.25984 5.40803 7.25984V5.77836ZM10.5932 5.77836V7.25984C11.0023 7.25984 11.334 6.9282 11.334 6.5191V5.77836H10.5932Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13617_107644"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.88889,
    height: 8.88889,
    fill: "white",
    transform: "translate(3.55609 3.55664)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResult);
export default __webpack_public_path__ + "static/media/Result.909bb73aa842f4206de54ffa74c0a4af.svg";
export { ForwardRef as ReactComponent };